import React, { useState } from "react";
import Input from "antd/es/input/Input";
import styles from "./Styles/Insurance.module.css";
import { DatePicker, Select } from "antd";
import moment from "moment";
import FileUpload from "../UploadFileNewComponent/UploadFile";
import TextInput from "../../common/text-input";
import Text from "../../common/typography/text";


export default function Insurance({ formData, setFormData }) {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFilesSecondary, setUploadedFilesSecondary] = useState([]);
  const updateField = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.sectionTitle}>INSURANCE DETAILS</h2>

      {/* PRIMARY INSURANCE */}
      <h3 className={styles.subTitle}>Primary Insurance Details</h3>

      <div className={styles.row}>
        <div className={styles.field}>
          <label className="form-label">Primary Insurance</label>
          <Input
            name="primaryInsurance"
            placeholder="Enter insurance company"
            value={formData.primaryInsurance || ""}
            onChange={updateField}
          />
        </div>

        <div className={styles.field}>
          <label className="form-label">
            Policy Number <span style={{ color: "red" }}>*</span>
          </label>
          <Input
            name="policyNumber"
            placeholder="XXXXXXXXXXX"
            value={formData.policyNumber || ""}
            onChange={updateField}
          />
        </div>

        <div className={styles.field}>
          <label className="form-label">Type of Plan</label>
          {/* <Select
            placeholder="Choose plan type"
            options={[
              { label: "HMO", value: "HMO" },
              { label: "PPO", value: "PPO" },
            ]}
            className={styles.select}
            value={formData.primaryPlanType || undefined} // antD requires undefined for empty
            onChange={(value) =>
              setFormData({ ...formData, primaryPlanType: value })
            }
          /> */}
          <Input
            placeholder="Enter plan type"
            value={formData.primaryPlanType || ""}
            onChange={(e) =>
              setFormData({ ...formData, primaryPlanType: e.target.value })
            }
            />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <label className="form-label">Subscriber Number</label>
          <Input
            name="subscriberNumber"
            placeholder="XXXXXXXXXXXX"
            value={formData.subscriberNumber || ""}
            onChange={updateField}
          />
        </div>

        <div className={styles.field}>
          <label className="form-label">Subscriber DOB</label>
          <DatePicker
            placeholder="Select Date"
            value={
              formData.subscriberDOB ? moment(formData.subscriberDOB) : null
            }
            onChange={(date, dateString) =>
              setFormData({ ...formData, subscriberDOB: dateString })
            }
            style={{
              width: "100%",
              height: 32,
              borderRadius: 6,
            }}
            dropdownStyle={{ borderRadius: 6 }}
          />
          <Text variant="tinyText" color="lightText">MM-DD-YYYY</Text>
        </div>

        <div className={styles.field}>
          <label className="form-label">Insurance Phone Number</label>
          <Input
            name="insurancePhone"
            placeholder="(XXX) XXX-XXXX"
            value={formData.insurancePhone || ""}
            onChange={updateField}
          />
        </div>

        <div className={styles.field}>
          <label className="form-label">Provider in Network</label>
          <Input
            name="providerNetwork"
            placeholder="Yes/No"
            value={formData.providerNetwork || ""}
            onChange={updateField}
          />
        </div>
      </div>

      {/* Patient Insurance Card */}
      <div className={styles.fileUploadSection}>
        <label className={styles.label}>Patient Insurance Card</label>

        <FileUpload
          uploadedFiles={uploadedFiles}
          setUploadedFiles={(files) => {
            setUploadedFiles(files);
            setFormData({ ...formData, patientInsuranceCardFiles: files });
          }}
          // screen="InsuranceDetails"
          // formData={formData}
          // setFormData={setFormData}
        />
      </div>

      {/* SECONDARY INSURANCE */}
      <h3 className={styles.subTitle}>Secondary Insurance Details</h3>

      <div className={styles.row}>
        <div className={styles.field}>
          <label className="form-label">Secondary Insurance</label>
          <Input
            name="secondaryInsurance"
            placeholder="Enter insurance company"
            value={formData.secondaryInsurance || ""}
            onChange={updateField}
          />
        </div>

        <div className={styles.field}>
          <label className="form-label">Policy Number</label>
          <Input
            name="secondaryPolicyNumber"
            placeholder="XXXXXXXXXXX"
            value={formData.secondaryPolicyNumber || ""}
            onChange={updateField}
          />
        </div>

        <div className={styles.field}>
          <label className="form-label">Type of Plan</label>
          {/* <Select
            placeholder="Choose plan type"
            options={[
              { label: "HMO", value: "HMO" },
              { label: "PPO", value: "PPO" },
            ]}
            className={styles.select}
            value={formData.secondaryPlanType || undefined}
            onChange={(value) =>
              setFormData({ ...formData, secondaryPlanType: value })
            }
          /> */}
          <Input
            placeholder="Enter plan type"
            value={formData.secondaryPlanType || ""}
            onChange={(e) =>
              setFormData({ ...formData, secondaryPlanType: e.target.value })
            }
            />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <label className="form-label">Subscriber Number</label>
          <Input
            name="secondarySubscriberNumber"
            placeholder="XXXXXXXXXXXX"
            value={formData.secondarySubscriberNumber || ""}
            onChange={updateField}
          />
        </div>

        <div className={styles.field}>
          <label className="form-label">Subscriber DOB</label>
          <DatePicker
            placeholder="Select Date"
            value={
              formData.secondarySubscriberDOB
                ? moment(formData.secondarySubscriberDOB)
                : null
            }
            onChange={(date, dateString) =>
              setFormData({ ...formData, secondarySubscriberDOB: dateString })
            }
            style={{
              width: "100%",
              height: 32,
              borderRadius: 6,
            }}
            dropdownStyle={{ borderRadius: 6 }}
          />
          <Text variant="tinyText" color="lightText">MM-DD-YYYY</Text>
        </div>

        <div className={styles.field}>
          <label className="form-label">Insurance Phone Number</label>
          <Input
            name="secondaryInsurancePhone"
            placeholder="(XXX) XXX-XXXX"
            value={formData.secondaryInsurancePhone || ""}
            onChange={updateField}
          />
        </div>

        <div className={styles.field}>
          <label className="form-label">Provider in Network</label>
          <Input
            name="secondaryProviderNetwork"
            placeholder="Yes/No"
            value={formData.secondaryProviderNetwork || ""}
            onChange={updateField}
          />
        </div>
      </div>

        {/* Secondary Insurance Card */}
      <div className={styles.fileUploadSection}>
        <label className={styles.label}>Secondary Insurance Card</label>
        <FileUpload
          uploadedFiles={uploadedFilesSecondary}
          setUploadedFiles={(files) => {
            setUploadedFilesSecondary(files);
            setFormData({ ...formData, secondaryInsuranceCardFiles: files });
          }}
          // screen="InsuranceDetails"
          // formData={formData}
          // setFormData={setFormData}
        />
      </div>
    </div>
  );
}
